<div
  id="mainSlider"
  class="mb-3 p-0"
  name="mainSlider"
  *ngIf="item | async as slides; else loading">
  <ng-container *ngIf="isBrowser">
    <carousel
      #sliderCarousel="carousel"
      [cellsToShow]="1"
      [loop]="true"
      [autoplayInterval]="sliderInterval"
      [autoplay]="true"
      (events)="handleCarouselEvents($event)">
      <ng-container *ngFor="let slide of slides">
        <ng-container
          *ngTemplateOutlet="carouselCell; context: { slide }"></ng-container>
      </ng-container>
    </carousel>
  </ng-container>
  <ng-container *ngIf="isServer">
    <ng-container
      *ngTemplateOutlet="
        carouselCell;
        context: { slide: slides[0] }
      "></ng-container>
  </ng-container>
</div>
<!-- carouselCell template -->
<ng-template #carouselCell let-slide="slide">
  <div class="carousel-cell">
    <div
      class="carousel-background d-none d-sm-block"
      width="2000"
      height="949"
      [defaultImage]="defaultImage"
      [lazyLoad]="slide.image_landscape | getImageUrlDirectus : 70">
      <div class="container">
        <div class="row align-items-end align-content-end pb-5">
          <div class="col-12 text-center mb-4">
            <h2>{{ slide | getTextDirecuts : 'title' : currLang }}</h2>
          </div>
          <div class="col-3 col-md-4">
            <p class="mb-0">
              {{ slide | getTextDirecuts : 'claim' : currLang }}
            </p>
          </div>
          <div class="col-12 col-sm-6 col-md-4 text-center">
            <a
              [routerLink]="['/trail', slide.url]"
              class="btn btn-orange mt-4"
              >{{ 'byt_trail_more' | translate }}</a
            >
          </div>
          <div class="col-3 col-md-4 text-end">
            <p class="mb-0">
              {{ slide | getTextDirecuts : 'text' : currLang }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="carousel-background d-sm-none"
      width="500"
      height="800"
      [defaultImage]="defaultImage"
      [lazyLoad]="slide.image_portrait | getImageUrlDirectus : 70">
      <div class="container">
        <div class="row align-items-end pb-5">
          <div class="col-12 col-sm-8 col-md-6 text-center">
            <h2>{{ slide | getTextDirecuts : 'title' : currLang }}</h2>
            <p>{{ slide | getTextDirecuts : 'claim' : currLang }}</p>
            <a
              [routerLink]="['/trail', slide.url]"
              class="btn btn-orange mt-3"
              >{{ 'byt_trail_more' | translate }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- loading template -->
<ng-template #loading>
  <div class="row vh-50 d-flex justify-content-center align-items-center">
    <div class="col-12">
      <app-spinner></app-spinner>
    </div>
  </div>
</ng-template>
